module.exports = __webpack_public_path__ + "static/img/labourservices-1.6e78899.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourservices-1.png
// module id = tpP8
// module chunks = 1